import { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IdentityContext from '../../contexts/IdentityContext';
import useClickOutside from '../../hooks/useClickOutside';
import Navigation from '@pelckmans/elementis/components/navigation';
import classNames from 'classnames';
import SettingsIcon from '@pelckmans/elementis/icons/settings';
import DropdownMenu from '@pelckmans/elementis/components/dropdown-menu';

export default function AdminMenu() {
  const {
    identity: { canAccessShell },
  } = useContext(IdentityContext);
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { REACT_APP_SHELL_URL, REACT_APP_RESHELL_URL } = process.env;

  useClickOutside({
    ref,
    elementId: 'admin-menu',
    onClickOutside: () => setShowMenu(false),
    enabled: showMenu,
  });

  if (!canAccessShell) return null;

  return (
    <div ref={ref} className="page-level-menu">
      <Navigation>
        <Navigation.List>
          <li role="none">
            <button
              role="menuitem"
              onClick={() => setShowMenu(prev => !prev)}
              className={classNames('menu-navigation-item', { active: showMenu })}
              aria-label={t('APP_NAV.SIDE_NAV.ADMIN_BUTTON.A11Y_LABEL')}
            >
              <SettingsIcon size="lg" focusable={false} aria-hidden="true" className="menu-navigation-item-icon" />
            </button>
          </li>
        </Navigation.List>
      </Navigation>

      {showMenu && (
        <DropdownMenu
          referenceEl={ref.current}
          menuProps={{
            ariaLabel: t('APP_NAV.SIDE_NAV.ADMIN_MENU.A11Y_LABEL'),
            id: 'admin-menu',
          }}
          role="menu"
          placement="right-end"
          offset={20}
          grow
          showSeparators
          disableBackgroundScroll
        >
          <DropdownMenu.Item as="link" href={REACT_APP_SHELL_URL} target="_blank" role="menuitem" text="Shell" />
          <DropdownMenu.Item as="link" href={REACT_APP_RESHELL_URL} target="_blank" role="menuitem" text="Reshell" />
        </DropdownMenu>
      )}
    </div>
  );
}
